// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import CoreMessages from '@core/scripts/components/message-list';
import ProductMessages from './message-list';
import WishlistHeart from '@core/scripts/components/wishlist/heart';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';

export default function WishlistButton({product, texts}) {
    const [currentStyle, setCurrentStyle] = useState(product.currentStyle);
    const [currentItem, setCurrentItem] = useState(product.currentItem);
    const [currentItemOption, setCurrentItemOption] = useState(product.currentItemOption);

    useEffect(() => {
        const subscription = MessageBroker.subscribe(ProductMessages.CHANGED, ({style, item, itemOption}) => {
            if (item !== undefined) {
                setCurrentItem(item);
            }
            if (style !== undefined) {
                setCurrentStyle(style);
            }
            if (itemOption !== undefined) {
                setCurrentItemOption(itemOption);
            }
        });

        return () => MessageBroker.unsubscribe(subscription);
    }, []);

    const onAddError = (error) => MessageBroker.publish(CoreMessages.WISHLIST.SHOW_ERROR_LAYER, {error: error});
    const onRemoveError = () => MessageBroker.publish(CoreMessages.WISHLIST.SHOW_ERROR_LAYER, {error: 'REMOVE'});

    const onItemAddCompleted = () => {
        LandmarkAdapter.sendUserInterfaceLandmark({
            click: 'adp_addwishlist',
        });
        MessageBroker.publish('WISH_STATS.UPDATE');
    };

    const onItemRemoveCompleted = () => {
        MessageBroker.publish('WISH_STATS.UPDATE');
    };


    const availabilitySource = (currentItemOption || currentItem || currentStyle || product).availability;


    return (
        <WishlistHeart
            className="design-system-button-with-text"
            testRefs={{"test-ref__add-to-wishlist-button": ""}}
            digistyleId={product.styleId}
            masterStyleId={product.masterStyleId}
            articleNumber={currentItem?.itemNumber}
            promotion={product.promotion}
            articlePrice={currentItemOption?.price?.unified?.value || currentItem?.price?.unified?.value}
            shopId={product.shopId}
            itemId={currentItem?.id}
            itemOptionId={currentItemOption?.id}
            itemOptionName={currentItemOption?.name}
            disabled={availabilitySource.soldOut}
            onAddError={onAddError}
            onAddSuccess={onItemAddCompleted}
            onRemoveError={onRemoveError}
            onRemoveSuccess={onItemRemoveCompleted}
            origin="adp"
            isMultiItem
        >{texts.ada12_add_to_wishlist}</WishlistHeart>
    );
}
